import React from 'react';
import Image from 'next/image';
import styled from '@benzinga/themetron';

interface CompanyLogoProps {
  logo: string;
  name: string;
  wrapperClassName?: string;
}

export const CompanyLogo: React.FC<CompanyLogoProps> = ({ logo, name, wrapperClassName }) => {
  if (!logo || !logo.trim()) {
    return <Container className="company-logo" />;
  }

  return (
    <Container className={['company-logo', wrapperClassName].filter(Boolean).join(' ')}>
      <Image alt={name} height={50} priority src={logo} width={50} />
    </Container>
  );
};

const Container = styled.div`
  &.company-logo {
    padding: 0.25rem;
    background-color: ${({ theme }) => theme.colorPalette.white};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 0.25rem;
    justify-content: center;
    align-items: center;
    display: flex;
  }
`;
